<script setup lang="ts">
import ErrorMessage from '@/corePagesModule/components/ErrorMessage.vue';
import { i18n } from '@/i18n';
import DateInput from '@/corePagesModule/components/DateInput.vue';

const t = i18n.t;

const props = withDefaults(
  defineProps<{
    /** modelValueはUnixTimeで受ける想定 */
    modelValue: number;
    label: string;
    isError?: boolean;
    errorMessage?: string;
    placeholder?: string;
    disabled?: boolean;
    format?: string;
  }>(),
  {
    errorMessage: undefined,
    placeholder: '選択してください',
    format: 'yyyy/MM/dd',
  }
);
const emits = defineEmits<{ (e: 'update:modelValue', value: number) }>();
</script>
<template>
  <div>
    <div class="date-input__label">
      <label v-if="label !== ''" :for="`date-input-${label}`" class="date-input__label-text">{{ label }}</label>
      <ErrorMessage :is-error="isError" :error-message="errorMessage" />
    </div>
    <DateInput
      :model-value="props.modelValue"
      :placeholder="props.placeholder"
      :disabled="props.disabled"
      :format="props.format"
      @update:model-value="emits('update:modelValue', $event)"
    />
  </div>
</template>
<style lang="scss" scoped>
.date-input {
  &__label {
    display: grid;
    grid-template-columns: auto auto;
    gap: 3px;
    justify-content: space-between;
    align-items: center;

    &-text {
      padding: 8px 0;
      font-family: Noto Sans JP;
      font-size: 14px;
      font-weight: 400;
      line-height: 18.2px;
      text-align: center;

      color: $textDefault;
    }
  }
}
</style>
